// Cache of the public access-control summary.
//
// The summary backs reviewer auto-fill on the submission form
// (§7) and the Authority Register sub-panel in Governance (§10.1).
// The store fetches once on first access and re-uses the snapshot
// for the rest of the session.

import { api } from './api';

export interface AccessControlUserSummary {
  email: string;
  display_name: string | null;
  github_username: string | null;
  roles: string[];
  added_at: string | null;
}

interface AccessControlState {
  loading: boolean;
  schema_version: string | null;
  users: AccessControlUserSummary[];
  error: string | null;
}

const state = $state<AccessControlState>({
  loading: false,
  schema_version: null,
  users: [],
  error: null
});

export const accessControlState = state;

export async function loadAccessControlSnapshot(): Promise<void> {
  if (state.users.length > 0 && !state.error) return;
  state.loading = true;
  state.error = null;
  try {
    const response = await api.accessControl();
    state.schema_version = response.schema_version;
    state.users = response.users;
    state.loading = false;
  } catch (err) {
    state.loading = false;
    state.error = err instanceof Error ? err.message : 'access_control_load_failed';
  }
}

export function reviewersWithRole(role: string): AccessControlUserSummary[] {
  return state.users.filter((u) => u.roles.includes(role));
}
